export const LatestStatisticsIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.75 6.75L10.6803 9.85461C10.2658 10.4764 9.33419 10.4184 9 9.75V9.75C8.66581 9.08162 7.73425 9.02363 7.31974 9.64539L5.25 12.75"
        stroke="#308D82"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="2.25" y="2.25" width="13.5" height="13.5" rx="2" stroke="#308D82" />
    </svg>
  );
};
